import { render } from "./AppRating.vue?vue&type=template&id=fe4146ba"
import script from "./AppRating.vue?vue&type=script&lang=js"
export * from "./AppRating.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__